/*
 * Popper v1 - required by Bootstrap Popovers and Tooltips
 */

import Popper from 'popper.js';
window.Popper = Popper;
